import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  PRICE_ADJUSTMENT_DISABLE_MODE_THIS_OCCURRENCE,
  PRICE_ADJUSTMENT_DISABLE_MODE_UNTIL_REENABLED,
  PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED,
} from '@/lib/services/price-adjustments/priceAdjustments.schema'
import {
  getPriceAdjustmentCardTitle,
  priceAdjustmentRepeatsAnnually,
} from '@/lib/services/price-adjustments/priceAdjustments.summary'

import { ConfirmationDialog } from '@/components/patterns/confirmation-dialog'

export function PriceAdjustmentDisableDialog({
  adjustment,
  isPending = false,
  onDisable,
  onOpenChange,
  open = false,
}) {
  const supportsSkipOccurrence =
    adjustment?.when_type === PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED &&
    priceAdjustmentRepeatsAnnually(adjustment)

  if (!supportsSkipOccurrence) {
    return (
      <ConfirmationDialog
        open={open}
        onOpenChange={onOpenChange}
        title="Disable price change?"
        description={`This will turn off ${getPriceAdjustmentCardTitle(adjustment)} until you re-enable it.`}
        confirmText="Disable price change"
        pendingText="Disabling..."
        isPending={isPending}
        onConfirm={() => onDisable?.(PRICE_ADJUSTMENT_DISABLE_MODE_UNTIL_REENABLED)}
        trigger={<span className="hidden" />}
        variant="question"
      />
    )
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="small">
        <DialogHeader>
          <DialogTitle>Disable price change?</DialogTitle>
          <DialogDescription>
            {`Choose whether to turn off ${getPriceAdjustmentCardTitle(adjustment)} until you re-enable it or only skip the current or next occurrence.`}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2 sm:justify-start">
          <Button
            type="button"
            variant="outline"
            disabled={isPending}
            onClick={() => onDisable?.(PRICE_ADJUSTMENT_DISABLE_MODE_UNTIL_REENABLED)}
          >
            Disable until I turn it back on
          </Button>
          {supportsSkipOccurrence ? (
            <Button
              type="button"
              disabled={isPending}
              onClick={() => onDisable?.(PRICE_ADJUSTMENT_DISABLE_MODE_THIS_OCCURRENCE)}
            >
              Just this occurrence
            </Button>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
